import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { FilterOptionModel } from '../../models/filter-option.model';
import { FilterTypeAutocompleteModel } from '../../models/filter-type-autocomplete.model';
import { Subscription } from 'rxjs';
import { AbstractFilterTypeComponent } from '../../models/abstract-filter-type.component';

@Component({
    selector: 'agpr-filter-autocomplete',
    templateUrl: './filter-autocomplete.component.html',
    styleUrls: ['./filter-autocomplete.component.scss'],
    providers: [
        {
            provide: AbstractFilterTypeComponent,
            useExisting: FilterAutocompleteComponent
        }
    ],
    standalone: false
})
export class FilterAutocompleteComponent extends AbstractFilterTypeComponent implements OnChanges, OnDestroy {
    @Input() declare filter: FilterTypeAutocompleteModel;

    value: string;
    valueForSuggestions: FilterOptionModel<any>[];

    optionsRequest: Subscription;

    ngOnChanges(): void {
        this.refresh();
    }

    ngOnDestroy(): void {
        if (this.optionsRequest) {
            this.optionsRequest.unsubscribe();
        }
    }

    refresh(): void {
        this.valueForSuggestions = this.filter.getCurrentValue();
    }

    handleChange(item: FilterOptionModel): void {
        if (!item) {
            return;
        }
        const val = [
            ...this.filter.getCurrentValue(),
            item
        ];
        this.filter.setCurrentValue(val);
        this.value = null;
        this.valueForSuggestions = val;
    }
}
